"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSessionPositionInTraceFilterValue = exports.normalizeLegacySessionPositionInTraceFilters = exports.normalizeLegacySessionPositionInTraceFilter = exports.getSessionPositionInTraceFilterMode = exports.normalizeLegacySessionPositionInTraceKey = void 0;
// `positionInTrace` only exists on the Sessions detail filter surface.
const normalizeLegacySessionPositionInTraceKey = (key) => key === "root" ? "first" : key;
exports.normalizeLegacySessionPositionInTraceKey = normalizeLegacySessionPositionInTraceKey;
const getSessionPositionInTraceFilterMode = (filter) => (0, exports.normalizeLegacySessionPositionInTraceKey)(filter.key) ?? "last";
exports.getSessionPositionInTraceFilterMode = getSessionPositionInTraceFilterMode;
const normalizeLegacySessionPositionInTraceFilter = (filter) => {
    const normalizedKey = (0, exports.normalizeLegacySessionPositionInTraceKey)(filter.key);
    return normalizedKey === filter.key
        ? filter
        : { ...filter, key: normalizedKey };
};
exports.normalizeLegacySessionPositionInTraceFilter = normalizeLegacySessionPositionInTraceFilter;
const normalizeLegacySessionPositionInTraceFilters = (filters) => filters.map((filter) => filter.type === "positionInTrace"
    ? (0, exports.normalizeLegacySessionPositionInTraceFilter)(filter)
    : filter);
exports.normalizeLegacySessionPositionInTraceFilters = normalizeLegacySessionPositionInTraceFilters;
const formatSessionPositionInTraceFilterValue = (filter) => {
    const mode = (0, exports.getSessionPositionInTraceFilterMode)(filter);
    if (mode === "first")
        return "1st";
    if (mode === "last")
        return "last";
    const ordinal = typeof filter.value === "number" ? ` ${filter.value}` : "";
    return `${mode === "nthFromStart" ? "nth from start" : "nth from end"}${ordinal}`;
};
exports.formatSessionPositionInTraceFilterValue = formatSessionPositionInTraceFilterValue;
